export const COLLECTION_PAGE_SIZE = 250;
export const MIN_CHECKOUT_PRICE = 120;